<template>
  <ModalDefault modal_id="searchReportHsmModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_1044')"
                :method="searchHsm"
                footer="y"
                icon="bx bx-search mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="row px-2 d-flex">
          <div class="col-md-4">
            <label class="mb-0">{{ getTranslations('expression_4') }}</label>
            <div class="input-group mb-3">
              <select class="input_forms form-control custom-select"
                      @change="histories.search_hsm.department_id = null; histories.search_hsm.operator_id = null;"
                      v-model="histories.search_hsm.channel_id">
                <option :value="null">{{ getTranslations('expression_7') }}</option>
                <option v-for="channel in channels.data"
                        v-if="channel.status_key === 1"
                        :key="channel.id"
                        :value="channel.id">
                  {{ channel.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <label class="mb-0">{{ getTranslations('expression_12') }} </label>
            <div class="input-group mb-3">
              <select class="input_forms form-control custom-select"
                      @change="histories.search_hsm.operator_id = null;"
                      v-model="histories.search_hsm.department_id">
                <option :value="null" selected>{{ getTranslations('expression_124') }}</option>
                <option v-for="department in getDepartmentsArray('channel_id', histories.search_hsm.channel_id)"
                        :key="department.id"
                        :value="department.id">
                  {{ department.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <label class="mb-0">{{ getTranslations('expression_48') }} </label>
            <div class="input-group mb-3">
              <select class="input_forms form-control custom-select"
                      v-model="histories.search_hsm.operator_id">
                <option :value="null" selected>Escolha um usuário</option>
                <option v-for="operator in getOperatorsArray('department_id', histories.search_hsm.department_id)"
                        :key="operator.id"
                        :value="operator.id">
                  {{ getUserObject('id', operator.user_id).name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_814') }} </label>
            <div class="input-group mb-3">
              <input type="date"

                    onfocus="this.showPicker()"
                    onclick="this.showPicker()"
                     v-model="histories.search_hsm.start_date"
                     class="input_forms form-control">
            </div>
          </div>
          <div class="col-md-6">
            <label class="mb-0">{{ getTranslations('expression_815') }} </label>
            <div class="input-group mb-3">
              <input type="date"

                    onfocus="this.showPicker()"
                    onclick="this.showPicker()"
                     v-model="histories.search_hsm.final_date"
                     class="input_forms form-control">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span data-dismiss="modal"
                @click.prevent="clearSearch"
                class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3 mr-2">
            <span class="">{{ getTranslations('expression_810') }}</span>
          </span>
      </div>
      <div>
          <span data-dismiss="modal"
                @click.prevent="searchHsm"
                class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_811') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalSearchReportHsm",
  components: {
    ModalDefault,
  },
  data(){
    return {
    }
  },
  computed: {
    ...mapState(['tickets', 'configs', 'channels', 'sources', 'me']),
    ...mapGetters([
      'getDepartmentsArray',
      'getOperatorsArray',
      'getInterestsArray',
      'getMotivesArray',
      'getUserObject',
    ])
  },
  methods: {
    clearSearch() {
      this.histories.search_hsm = {
        channel_id: null,
        department_id: null,
        operator_id: null,
        start_date: null,
        final_date: null,
        per_page: 10
      }
      this.searchHsm()
    },
    searchHsm(){
      this.$store.dispatch('getHistoriesHsm', this.histories.search_hsm)
    },
  }
}
</script>

<style scoped>

</style>
